module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( itemsCount ) { 
__p+='\n	<h5 class="count">'+
((__t=( paginationInfo ))==null?'':__t)+
'</h5>\n';
 } 
__p+='\n\n<div class="paginator">\n	<a href="" class="paginator-button ratings-prev ';
 if ( hasPrev ) print('show') 
__p+='">&larr;</a>\n	<a href="" class="paginator-button ratings-next ';
 if ( hasNext ) print('show') 
__p+='">&rarr;</a>\n</div>\n\n<div class="rating-list">\n\n	';
 if ( itemsCount ) { 
__p+='\n		';
 _.each(items, function(item) { 
__p+='\n\n			<div class="rating">\n\n				<div class="content">\n					\n					<h3>'+
((__t=( item.titel ))==null?'':__t)+
'</h3>\n					<div class="text">'+
((__t=( item.text ))==null?'':__t)+
'</div>\n\n					';
 if ( item.response.length > 0 ) { 
__p+='\n						<div class="response_group">\n							';
 _.each(item.response, function(response) { 
__p+='\n								<div class="response">\n									<div class="info">\n										<span class="username">'+
((__t=( response.username ))==null?'':__t)+
'</span>\n										<span class="datum"> am '+
((__t=( response.datum ))==null?'':__t)+
'</span>\n									</div>\n									'+
((__t=( response.text ))==null?'':__t)+
'\n								</div>\n							';
 }); 
__p+='\n						</div>\n					';
 } 
__p+='\n\n				</div>\n\n				<div class="context">\n					\n					'+
((__t=( __('rated_on') ))==null?'':__t)+
' '+
((__t=( moment( item.created, "YYYY-MM-DD").format("L") ))==null?'':__t)+
'<br>\n					<br>\n\n					<div class="stars">\n						';
 if ( item.rating_1 == 1 ) print("<span>&#10029;</span>") 
__p+='\n						';
 if ( item.rating_1 == 2 ) print("<span>&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_1 == 3 ) print("<span>&#10029;&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_1 == 4 ) print("<span>&#10029;&#10029;&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_1 == 5 ) print("<span>&#10029;&#10029;&#10029;&#10029;&#10029;</span>") 
__p+='&nbsp;&nbsp;'+
((__t=( __('rating_1') ))==null?'':__t)+
'<br>\n						\n						';
 if ( item.rating_2 == 1 ) print("<span>&#10029;</span>") 
__p+='\n						';
 if ( item.rating_2 == 2 ) print("<span>&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_2 == 3 ) print("<span>&#10029;&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_2 == 4 ) print("<span>&#10029;&#10029;&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_2 == 5 ) print("<span>&#10029;&#10029;&#10029;&#10029;&#10029;</span>") 
__p+='&nbsp;&nbsp;'+
((__t=( __('rating_2') ))==null?'':__t)+
'<br>\n					\n						';
 if ( item.rating_3 == 1 ) print("<span>&#10029;</span>") 
__p+='\n						';
 if ( item.rating_3 == 2 ) print("<span>&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_3 == 3 ) print("<span>&#10029;&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_3 == 4 ) print("<span>&#10029;&#10029;&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_3 == 5 ) print("<span>&#10029;&#10029;&#10029;&#10029;&#10029;</span>") 
__p+='&nbsp;&nbsp;'+
((__t=( __('rating_3') ))==null?'':__t)+
'<br>\n					\n						';
 if ( item.rating_4 == 1 ) print("<span>&#10029;</span>") 
__p+='\n						';
 if ( item.rating_4 == 2 ) print("<span>&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_4 == 3 ) print("<span>&#10029;&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_4 == 4 ) print("<span>&#10029;&#10029;&#10029;&#10029;</span>") 
__p+='\n						';
 if ( item.rating_4 == 5 ) print("<span>&#10029;&#10029;&#10029;&#10029;&#10029;</span>") 
__p+='&nbsp;&nbsp;'+
((__t=( __('rating_4') ))==null?'':__t)+
'<br>\n					</div>\n					<br>\n	\n					\n					'+
((__t=( __('age') ))==null?'':__t)+
': '+
((__t=( __('age_range', {from: parseInt(item.extra_alter) - 5, to: parseInt(item.extra_alter) + 4}) ))==null?'':__t)+
'\n					<br>\n		\n					'+
((__t=( __('traveled_as_' + item.extra_typ) ))==null?'':__t)+
'\n					<br>\n\n					';
 if ( item.extra_dauer == 7 ) { 
__p+=' '+
((__t=( __('for_one_week') ))==null?'':__t)+
'\n					';
 } else if ( item.extra_dauer == 14 ) { 
__p+=' '+
((__t=( __('for_two_weeks') ))==null?'':__t)+
'\n					';
 } else { print(__('for_x_days', {days: item.extra_dauer})) } 
__p+='\n					<br>\n\n					';
 if ( item.jahr_tag >= 355 || item.jahr_tag < 79 ) print(__("in_winter")) 
__p+=' \n					';
 if ( item.jahr_tag >= 79 && item.jahr_tag < 172 ) print(__("in_spring")) 
__p+=' \n					';
 if ( item.jahr_tag >= 172 && item.jahr_tag < 266 ) print(__("in_summer")) 
__p+=' \n					';
 if ( item.jahr_tag >= 266 && item.jahr_tag < 355 ) print(__("in_autumn")) 
__p+=' '+
((__t=( item.jahr ))==null?'':__t)+
'\n\n			       \n				';
 if ( window.Tramino.client !== 100 ) { 
__p+='\n					<div class="rating-button"><a href="?rate_client='+
((__t=( client ))==null?'':__t)+
'#detail-rating-tramino">'+
((__t=( __('add_rating') ))==null?'':__t)+
'</a></div>\n				';
 } else { 
__p+='\n					<div class="rating-button"><a href="/gastgeber/bewertung.html?client='+
((__t=( client ))==null?'':__t)+
'">'+
((__t=( __('add_rating') ))==null?'':__t)+
'</a></div>\n				';
 } 
__p+='			        \n					\n\n\n				</div>\n		     	\n		     	<div class="clear"></div>\n\n	        </div>\n\n		';
 }); 
__p+='\n	';
 } else { 
__p+='\n		<div class="notification">'+
((__t=( __('no_ratings') ))==null?'':__t)+
'</div>\n	';
 } 
__p+='\n	\n	<div class="clear"></div>\n\n</div>\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/miniengine/ratings-template.html
 ** module id = 74
 ** module chunks = 0
 **/